import { cn } from '@/utils';
import { type NewMapBannerSize } from './NewMapBanner';
export const TextSection = ({
  title,
  description,
  backgroundColor,
  size
}: {
  title: string;
  description?: string;
  backgroundColor: string;
  size: NewMapBannerSize;
}) => {
  return <div className={cn('flex h-full w-full flex-1 flex-col justify-center overflow-hidden py-sm pl-3xs pr-sm text-body-md-bold text-white rounded-r-md', size === 'sm' && 'rounded-r-sm')} style={{
    backgroundColor,
    WebkitTextStrokeWidth: '1px',
    WebkitTextStrokeColor: 'rgba(28, 27, 31, 0.04)'
  }} data-sentry-component="TextSection" data-sentry-source-file="TextSection.tsx">
      <span className="line-clamp-2 pt-[2px]">{title}</span>
      {description && <span className="truncate">{description}</span>}
    </div>;
};